class SiteHeader {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-siteheader',
            toggleAttr: 'toggle',
            closeNavigationAttr: 'close-navigation',
            scrollOffset: 40
        };

        this.settings = Object.assign({}, defaults, options);
        this.$siteHeader = $element;
        this.$siteHeaderToggles = this.$siteHeader.querySelectorAll(`[${this.settings.initAttr}="${this.settings.toggleAttr}"]`);
        this.$searchToggle = this.$siteHeader.querySelector('#search-toggle');
        this.$searchInput = this.$siteHeader.querySelector('[data-search-bar-input]');
        this.$navigationToggle = this.$siteHeader.querySelector('#navigation-toggle');
        this.eventScroller = window.eventScroller;
        this.currentScrollPosition = window.scrollY;
        this.backScrolling = false;

        window.setTimeout(() => {
            this.initialize();
        }, 100);
    }

    initialize () {
        this.checkPagePosition();
        this.eventScroller.customFunctions.push(() => {
            this.checkPagePosition();
        });

        this.initToggles();
        this.initNavigationClose();
    }

    initToggles () {
        this.$siteHeaderToggles.forEach($toggle => {
            $toggle.addEventListener('change', () => {
                this.unCheckToggles($toggle);
                this.toggleSearchInputFocus($toggle);
            });
        });
    }

    initNavigationClose () {
        if (!this.$navigationToggle) {
            return;
        }

        // delegated so it also works for closers that are (re)rendered after init
        this.$siteHeader.addEventListener('click', (e) => {
            const $closer = e.target.closest(`[${this.settings.initAttr}="${this.settings.closeNavigationAttr}"]`);

            if ($closer) {
                this.closeNavigation();
            }
        });
    }

    closeNavigation () {
        if (!this.$navigationToggle || this.$navigationToggle.checked === false) {
            return;
        }

        this.$navigationToggle.checked = false;
        this.$navigationToggle.dispatchEvent(new Event('change', { bubbles: true }));
    }

    checkPagePosition () {
        if (window.scrollY > this.settings.scrollOffset) {
            this.$siteHeader.classList.add('siteheader--sticky');

            if (window.scrollDirection === 'up') {
                if (this.backScrolling === false) {
                    this.currentScrollPosition = window.scrollPosition;
                    this.backScrolling = true;
                }

                if (!this.$siteHeader.classList.contains('siteheader--up') && window.scrollPosition <= this.currentScrollPosition - this.settings.scrollOffset) {
                    this.$siteHeader.classList.add('siteheader--up');
                }
            } else {
                if (this.$siteHeader.classList.contains('siteheader--up')) {
                    this.$siteHeader.classList.remove('siteheader--up');
                    this.backScrolling = false;
                }
            }
        } else {
            this.$siteHeader.classList.remove('siteheader--sticky');
            this.$siteHeader.classList.remove('siteheader--up');
        }
    }

    toggleSearchInputFocus ($activeToggle) {
        if ($activeToggle.checked && $activeToggle === this.$searchToggle) {
            console.log('focus');
            this.$searchInput.focus();
        }

        if (($activeToggle.checked && $activeToggle !== this.$searchToggle) || (!$activeToggle.checked && $activeToggle === this.$searchToggle)) {
            console.log('blur');
            this.$searchInput.blur();
        }
    }

    unCheckToggles ($activeToggle) {
        this.$siteHeaderToggles.forEach($toggle => {
            if ($toggle !== $activeToggle) {
                $toggle.checked = false;
            }
        });
    }
}

export default SiteHeader;
